module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e9fd9649a5e891c8811243c4543e986e.png";